import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@contexts/AuthContext';

/**
 * Component to handle authentication redirects
 * Must be used inside Router context
 */
const AuthRedirectHandler: React.FC = () => {
  const { user, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Only redirect to dashboard if user is on root path or login page
    if (isAuthenticated && user && (location.pathname === '/' || location.pathname === '/login')) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, user, navigate, location.pathname]);

  return null; // This component doesn't render anything
};

export default AuthRedirectHandler;

